import __ from "ramda/es/__";
import append from "ramda/es/append";
import curry from "ramda/es/curry";
import has from "ramda/es/has";
import is from "ramda/es/is";
import when from "ramda/es/when";
export const alterWithDefaultBeforeLogout = (beforeLogout)=>(action)=>({
            beforeLogout,
            ...action
        });
export const appendApiRequestActions = curry((apiActions, modalActions, paramName)=>{
    if (is(Array)(apiActions[paramName])) {
        for (const action of apiActions[paramName]){
            modalActions[paramName] = append(action, modalActions[paramName]);
        }
    } else {
        modalActions[paramName] = append(apiActions[paramName], modalActions[paramName]);
    }
});
export const checkAndAppendApiRequestActions = curry((apiActions, appendActions, paramName)=>when(has(__, apiActions), appendActions)(paramName));
